module.exports = __webpack_public_path__ + "./assets/img_kao_color@2x__4e5b3bdf59decb34106e7fffb174800d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_kao_color@2x.jpg
// module id = 625
// module chunks = 12